import { useEffect, useRef } from 'react';

/**
 * Runs the callback when the pull-to-refresh signal changes.
 * Skips the initial mount — `refreshSignal` is initialized to 0 in
 * PrivateOutlet, so without this guard the effect fires on first render
 * and duplicates the page's own mount fetch (double API calls).
 *
 * @param {number} refreshSignal - counter from `useOutletContext()`
 * @param {Function} callback - fetch function to run on refresh
 */
function useRefreshSignal(refreshSignal, callback) {
    const isFirstRun = useRef(true);
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        callbackRef.current();
    }, [refreshSignal]);
}

export default useRefreshSignal;
